import {usePlayerContext} from '../../hooks/usePlayerContext';
import {ControlButton} from '../controlButton';
import VolumeIcon from './volumeIcon.svg';
import MutedIcon from './mutedIcon.svg';
import {useIsMuted} from '../../hooks/usePlayerState';
import {VFC} from 'react';

export const MuteUnmuteButton: VFC = () => {
  const {player} = usePlayerContext();
  const isMuted = useIsMuted();
  const label = isMuted ? 'Unmute' : 'Mute';

  const onClick = (): void => {
    if (!player) return;

    if (player.isMuted()) {
      // If the current volume of the player is 0, set the volume to 100
      if (player.getVolume() === 0) {
        player.setVolume(100);
      }

      player.unmute('ui');
    } else {
      player.mute('ui');
    }
  };

  return (
    <ControlButton
      ariaLabel={label}
      ariaPressed={isMuted}
      tooltipLabel={label}
      onClick={onClick}
    >
      {isMuted ? <MutedIcon /> : <VolumeIcon />}
    </ControlButton>
  );
};
